import { Component, Inject } from "@angular/core";
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from "@angular/material/snack-bar";
import { SlugName } from "@app2/ticket/ticket-constants";

type NotificationData = { key: string, updatedAlerts: number, slugName: SlugName, slugId: number };

@Component({
    selector: "alert-ticket-action-notification",
    template: `
        <notification-icon type="success"></notification-icon>
        <div class="notification-body">
            {{ data.key | localize }}
            <a class="link-text"
               (click)="dismissSnackbar()"
               [dsRouterLink]="['/tickets', data.slugName, data.slugId]">
                {{data.slugName}}/{{data.slugId}}
            </a>
            <br/>
            <ng-container *ngIf="data.updatedAlerts !== null">
                {{ "ALERT_STATE_CHANGE_PARTIAL" | localize: data.updatedAlerts }}
            </ng-container>
        </div>
    `,
    host: {
        class: "notification-message",
    },
    styles: [`
        .notification-body {
            flex-grow: 1
        }
    `],
})
//TODO: rename this class removing "Alert"
export class AlertTicketActionNotificationComponent {
    constructor(public snackBarRef: MatSnackBarRef<AlertTicketActionNotificationComponent>,
                @Inject(MAT_SNACK_BAR_DATA) public data: NotificationData) {
    }

    dismissSnackbar() {
        this.snackBarRef.dismissWithAction();
    }
}
